import React from 'react';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';
import { WizardFormValidationErrorSummary } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-validation-error-summary/wizard-form-validation-error-summary';

import { UpdateForecastForm } from '../../components/update-forecast-form';
import { useUpdateForecastContext } from '../../context/update-forecast-context';

export interface UpdateForecastFormWizardScreenProps {
  error?: string;
  onClose: () => void;
  onUpdate: () => void;
}

export const UpdateForecastFormWizardScreen = ({ error, onClose, onUpdate }: UpdateForecastFormWizardScreenProps) => {
  const { form } = useUpdateForecastContext();

  return (
    <WizardScreen
      onCancel={onClose}
      onUpdate={onUpdate}
      footerMode={FooterMode.UPDATE}
      updateDisabled={!form.isDirty}
    >
      <>
        {error && <WizardFormError mb={3} />}
        <WizardFormValidationErrorSummary errors={form.errors} mb={3} />
        <UpdateForecastForm
          duration={form.duration}
          errors={form.errors}
          formType={form.formType}
          from={form.from}
          maxDate={form.maxDate}
          minDate={form.minDate}
          name={form.name}
          onChangeDuration={form.onChangeDuration}
          onChangeFrom={form.onChangeFrom}
          onChangeName={form.onChangeName}
          onChangePreviousActuals={form.onChangePreviousActuals}
          previousActuals={form.previousActuals}
          revalidate={form.revalidate}
        />
      </>
    </WizardScreen>
  );
};
